import React from 'react';

export default function ConversationList({
    conversations,
    activeSessionId,
    isLoading,
    isLoadingList,
    onSelect,
    onDelete,
    onNew,
}) {
    return (
        <aside className="conversation-list">
            <button className="btn-new" onClick={onNew} disabled={isLoading}>
                {isLoading ? '...' : '+ Nueva conversación'}
            </button>

            {isLoadingList && (
                <div className="conversation-list__skeleton">
                    {[1, 2, 3, 4, 5].map((i) => (
                        <div key={i} className="skeleton-item" aria-hidden="true">
                            <div className="skeleton-line skeleton-line--title" />
                            <div className="skeleton-line skeleton-line--date" />
                        </div>
                    ))}
                </div>
            )}

            <ul>
                {conversations.map((conv) => (
                    <li
                        key={conv.sessionId}
                        className={`${conv.sessionId === activeSessionId ? 'active' : ''} ${isLoading && conv.sessionId === activeSessionId ? 'loading' : ''}`}
                    >
                        <button
                            className="conv-item"
                            onClick={() => onSelect(conv.sessionId)}
                            disabled={isLoading}
                        >
                            <span className="conv-title">{conv.title}</span>
                            <span className="conv-date">
                                {new Date(conv.updatedAt).toLocaleDateString()}
                            </span>
                        </button>
                        <button
                            className="btn-delete"
                            onClick={(e) => {
                                e.stopPropagation();
                                onDelete(conv.sessionId);
                            }}
                            aria-label={`Delete ${conv.title}`}
                            disabled={isLoading}
                        >
                            ×
                        </button>
                    </li>
                ))}
            </ul>

            {!isLoadingList && conversations.length === 0 && (
                <p className="conversation-list__empty">No hay conversaciones aún.</p>
            )}
        </aside>
    );
}
